import Link from '@components/atoms/Link';
import Typography from '@components/atoms/Typography';

import { MenuItem } from '@templates/FooterMenu/FooterMenu.types';
import classes from './MenuList.module.scss';

type Props = Omit<MenuItem, 'id'>;

const MenuList = ({ items, name }: Props): JSX.Element => (
  <section className={!name ? classes.emptySection : undefined}>
    <Typography renderAs="div" variant="h4" weight="700">
      {name}
    </Typography>
    <ul className={classes.listWrapper}>
      {items?.map(({ id, url, name: itemName }) => (
        <li key={id}>
          <Link component="span" href={url} underline="hover">
            <Typography variant="body2" renderAs="span" lineHeight="28px">
              {itemName}
            </Typography>
          </Link>
        </li>
      ))}
    </ul>
  </section>
);

export default MenuList;
